// extracted by mini-css-extract-plugin
module.exports = {"container":"Dq-z","disabled":"Eq-z","bgBlack":"Fq-z","content":"Gq-z","countdown":"Hq-z","topCaption":"Iq-z","topHeading":"Jq-z","heading":"Kq-z","copy":"Lq-z"};